<template>
    <b-dropdown id="dropdown_template_settings" variant="outline-success" no-caret>

        <template v-slot:button-content>
            <a href="#" class="header-icon" data-toggle="modal" data-target="js-modal-settings">
                <i class="fal fa-cog"></i>
            </a>
        </template>

        <b-dropdown-form class="notif_user dropdown-xl settings-panel">
            <div class="dropdown-header bg-trans-gradient d-flex justify-content-center align-items-center rounded-top">
                <h4 data-v-7149ec54="" class="m-0 text-center color-white">Налаштування Шаблону
                    <small data-v-7149ec54="" class="mb-0 opacity-80">
                        Тут ви можете обрати свій варіант кольору та схеми
                    </small>
                </h4>
            </div>


            <div class="list mt-1">
                <span class="onoffswitch-title">Загальний Розмір</span>

                <div class="btn-group btn-group-sm btn-group-toggle my-2" data-toggle="buttons">

                    <label class="btn btn-default btn-sm waves-effect waves-themed"
                           data-action="toggle-swap"
                           v-bind:data-class=size.type
                           data-target="html"
                           v-on:click="set_active_size(size)"
                           v-for="size in template_sizes">
                        <input type="radio" name="changeFrontSize" > {{size.name}}
                    </label>


                </div>
            </div>

            <div class="mt-4 d-table w-100 pl-5 pr-3">
                <div class="d-table-cell align-middle">
                    <h5 class="p-0 pr-2 d-flex">Схеми шаблону</h5>
                </div>
            </div>


            <div class="pl-5 pr-3 py-3">
                <div class="row no-gutters">
                    <div class="col-4 pr-2 text-center" v-for="template in template_skins">
                        <div :id="template.id" v-bind:class="template.inside_class.add_class"
                             class="d-flex bg-white border rounded overflow-hidden text-success js-waves-on waves-effect waves-themed"
                             style="height: 80px" v-on:click="set_skin(template)" data-placement="top" data-replaceclass="">
                            <div class="px-2 pt-0 border-right"  v-bind:class="template.inside_class.left_class"></div>

                            <div class="d-flex flex-column flex-1">
                                <div class="border-bottom py-1" v-bind:class="template.inside_class.level1"></div>
                                <div class="flex-1 pt-3 pb-3 px-2" v-bind:class="template.inside_class.level2" ></div>
                            </div>
                        </div>
                        {{template.name}}
                    </div>
                </div>
            </div>

            <div class="mt-4 d-table w-100 pl-5 pr-3">
                <div class="d-table-cell align-middle">
                    <h5 class="p-0 pr-2 d-flex">Кольорова гамма</h5>
                </div>
            </div>

            <div class="pl-3 pr-3 py-3">
                <div class="expanded theme-colors ">
                    <ul class="m-0">
                        <li v-for="color in template_colors" :class="{'active' : color.is_active}"  v-on:click.stop.prevent="set_color(color)">
                            <a href="#" data-action="" :id="color.div_id" title="">
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="pl-3 pr-3 py-3">
                <button type="button" class="btn btn-lg btn-outline-success waves-effect waves-themed" v-on:click="save_settings">
                    <span class="fal fal fa-check mr-1"></span>
                    Зберегти
                </button>
            </div>

        </b-dropdown-form>
    </b-dropdown>
</template>

<script>
    export default {
        name: "user_app_settings",
        data: function () {
            return {

                template_sizes : [],

                template_skins : [
                    {
                        name : "Standart",
                        type : "main_templ",
                        id : "skin-default",

                        inside_class : {
                            add_class : {
                                "border-primary": true,
                            },
                            left_class : {
                                "bg-primary-600" : true,
                                "bg-primary-gradient" : true,
                                "border-primary" : true,
                            },
                            level1 : {
                                "bg-white" : true,
                                "border-primary" : true,
                            },
                            level2 : {
                                "bg-faded" : true
                            }
                        },

                        is_active : true,
                    },
                    {
                        name : "White",
                        type : "mod-skin-light",
                        id : "skin-light",
                        inside_class : {
                            add_class : {
                                "border" : true
                            },
                            left_class : {
                                "bg-white" : true,
                            },
                            level1 : {
                                "bg-white" : true,
                              //  "border-primary" : true,
                            },
                            level2 : {
                                "bg-white" : true,
                            }
                        },

                        is_active : false,
                    },
                    {
                        name : "Dark",
                        type : "mod-skin-dark",
                        id : "skin-dark",
                        inside_class : {
                            add_class : {
                                "border-dark": true,
                            },
                            left_class : {
                                "bg-fusion-500" : true,
                            },
                            level1 : {
                                "bg-fusion-600" : true,
                            },
                            level2 : {
                                "bg-fusion-300" : true
                            }
                        },


                        is_active : false,
                    },

                ],

                template_colors : [
                    {
                        div_id : "myapp-0",
                        id : 0,
                        css_file : "",
                        type : "",
                        is_active : true,
                    },
                ]
            }
        },

        created () {
            this.loadColors();
            this.loadSizes();

        },

        methods : {
           async set_color(color) {
                this.template_colors.map(item => {
                    item.is_active = color.id === item.id;
                });

                if(parseInt(color.id) > 0) {
                    await portal_api.post('/internal/template/get_color',{
                        "color_id" : parseInt(color.id)
                    }).then(({data}) => {
                        if (data.status == "operation_success") {
                            if ($(myapp_config.mythemeAnchor).length) {
                                 $(myapp_config.mythemeAnchor).attr('href', data.data );
                            } else {

                             let  mytheme = $("<link>", {
                                    id: myapp_config.mythemeAnchor.replace('#', ''),
                                    "rel": "stylesheet",
                                    "href" : data.data
                                 });

                                $('head').append(mytheme);
                            }
                        }
                    });
                }
                else {
                    if ($(myapp_config.mythemeAnchor).length) {
                        $(myapp_config.mythemeAnchor).attr("href", "");
                    }
                    //standart
                }
            },

            async set_active_size(size) {
                this.template_sizes.map(item => {
                    item.is_active = false;
                    if(item.id == size.id) {
                        item.is_active = true;
                    }
                });
            },

            async loadSizes() {
                await portal_api.post('/internal/template.get_sizes').then(({data}) => {
                    if (data.status == "operation_success") {
                        if(data.data.length > 0 ) {
                            data.data.map(item => {
                                this.template_sizes.push(item);
                            });
                        }

                        // this.template_colors = data.message;
                    }
                })
            },

            async loadColors() {
                await portal_api.post('/internal/template.get_colors').then(({data}) => {
                    if (data.status == "operation_success") {
                        if(data.data.length > 0 ) {
                            data.data.map(item => {
                               this.template_colors.push(item);
                            });
                        }

                       // this.template_colors = data.message;
                    }
                })
            },

            async save_settings () {
                await portal_api.post('/internal/template.save_settings', {
                            skin_active: this.template_active_skin,
                            color_active: this.template_active_color,
                            size_active: this.template_active_size
                        }
                    )
                    .then(({data}) => {
                        IMC_CORE.hideloading();
                        if (data.status == "operation_success") {
                            IMC_CORE.snackbar('Успішно виконано')
                        } else {
                            EventBus.$emit('show_toast', {err: data.message, type: "danger", title: data.status})
                        }
                    }).catch(err => {
						IMC_CORE.hideloading();
                        this.is_save_inactive = false;
                        EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
                    });
            },


            set_skin(template)  {
                jQuery("body").addClass(template.type);
                this.template_skins.map(item => {
                    item.is_active = false;
                   if(item.type !== template.type) {
                       jQuery("body").removeClass(item.type);
                   }
                });


                template.is_active = true;

            }
        },

        computed : {
            template_active_skin () {
                let active = "";
                this.template_skins.map(item => {
                    if(item.is_active) {
                        active = item.type;
                    }
                });

                return active;
            },
            template_active_color () {
                let active = "";
                this.template_colors.map(item => {
                    if(item.is_active) {
                        active = item.id;
                    }
                });

                return active;
            },

            template_active_size () {
                let active = "root-text";
                this.template_sizes.map(item => {
                    if(item.is_active) {
                        active = item.type;
                    }
                });

                return active;
            },

        },


    }
</script>

<style scoped>
    .notif_user {
        min-width: 350px;
    }
    .theme-colors li:not('.active') a {
        box-shadow : none !important;
    }

    .theme-colors li.active a {
        box-shadow: inset 0 0 0 3px rgb(43, 161, 255);
    }

</style>
